import { render, staticRenderFns } from "./Ordenar.vue?vue&type=template&id=3ef2c59a&scoped=true"
import script from "./Ordenar.vue?vue&type=script&lang=js"
export * from "./Ordenar.vue?vue&type=script&lang=js"
import style0 from "./Ordenar.vue?vue&type=style&index=0&id=3ef2c59a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef2c59a",
  null
  
)

export default component.exports